import { Table as DataTable } from "antd";
import "./style.less";

const Table: React.FC<any> = ({ dataSource, columns, ...others }: any) => {
  return <DataTable dataSource={dataSource} columns={columns} {...others} />;
};

export default Table;
